function trackFooterLogoClick() {
  const footerLogo = document.querySelector('.js_page-footer__index-link') || document.querySelector('.js_sitebranding-wrap a');

  if (footerLogo) {
    footerLogo.addEventListener('click', function (e) {
      const linkUrl = this.href;

      const gtmEvent = {
        trigger: 'click on logo',
        event_id: '1.7',
        event: 'select_content',
        link_url: linkUrl,
        event_campaign: 'general',
        content_type: 'logo footer',
        category: 'navigation',
        market: window.getMarketFromUrl()
      };

      window.dataLayer.push(gtmEvent);
    });
  }
}


function trackTeaser() {
  const teaserCardLinks = document.querySelectorAll('.promotion-sec .js_teaser-card__link');

  if (teaserCardLinks) {
    teaserCardLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        const linkUrl = this.href;
        const contentTitle = this.querySelector('.teaser-card__title').textContent.trim();

        const gtmEvent = {
          trigger: 'click on teaser',
          event_id: '1.5',
          event: 'select_content',
          link_url: linkUrl,
          event_campaign: 'general',
          content_type: 'teaser',
          content_id: contentTitle,
          market: window.getMarketFromUrl()
        };

        window.dataLayer.push(gtmEvent);
      });
    });
  }
}


function trackFooterSocialNav() {
  const socialNavLinks = document.querySelectorAll('.social-nav .social-nav-link');

  if (socialNavLinks) {
    socialNavLinks.forEach(link => {
      link.addEventListener('click', function (e) {
        const linkUrl = window.location.href;
        const platform = this.getAttribute("aria-label");

        const gtmEvent = {
          trigger: 'share footer',
          event_id: '1.14',
          event: 'share',
          link_url: linkUrl,
          event_campaign: 'general',
          content_type: 'share footer',
          category: 'general',
          method: platform,
          market: window.getMarketFromUrl()
        };

        window.dataLayer.push(gtmEvent);
      });
    });
  }

}

function trackHeaderTeaser() {
  const headerLink = document.querySelector('#sun_header_text .sun_header__link');

  if (headerLink) {
    headerLink.addEventListener('click', function (e) {
      const linkUrl = window.location.href;

      const gtmEvent = {
        trigger: 'click on header',
        event_id: '1.15',
        event: 'select_content',
        link_url: linkUrl,
        event_campaign: 'general',
        content_type: 'header_teaser',
        category: 'general',
      };

      window.dataLayer.push(gtmEvent);
    });
  }

}

function trackKombuchaProducts() {
  const kombuchaProducts = document.querySelectorAll('.kombucha-product-slider .product-slider__card-link');

  if (kombuchaProducts) {
    kombuchaProducts.forEach(link => {
      link.addEventListener('click', function (e) {
        const linkUrl = window.location.href;

        const productName = this.getAttribute("data-product-title");

        const gtmEvent = {
          trigger: 'click on komubcha product',
          event_id: '1.16',
          event: 'select_content',
          link_url: linkUrl,
          event_campaign: 'kombucha',
          content_type: 'product slider',
          category: 'products',
          content_id: productName,
        };
        
        window.dataLayer.push(gtmEvent);
      });
    });
  }

}

trackTeaser();
trackFooterLogoClick();
trackFooterSocialNav();
trackHeaderTeaser();
trackKombuchaProducts();